import { Component, OnInit, Input } from '@angular/core';
import { SubMenu } from 'src/app/types/type';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.css']
})
export class SubMenuComponent implements OnInit {
  @Input() subMenus: SubMenu[];
  constructor() { }

  ngOnInit() {
  }

}
